import React from 'react';

import PlusIcon from 'mdi-react/PlusIcon';
import MinusIcon from 'mdi-react/MinusIcon';
import { Item } from '../sharedTypes';

import * as S from './styles';

type QuantityControlsProps = {
  item: Item;
  updateQuantity: (id: number, quantity: number) => void;
};

const QuantityControls = ({ item, updateQuantity }: QuantityControlsProps) => {
  return item.__typename === 'ListProduct' && item.quantity >= 0 ? (
    <S.QuantityControls>
      <S.QuantityButton
        variant="icon"
        size="small"
        color="secondary"
        disabled={item.quantity <= 0}
        onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          e.stopPropagation();
          updateQuantity(item.id, item.quantity - 1);
        }}
        icon={<MinusIcon size={20} />}
      />

      <S.QuantityButton
        variant="icon"
        size="small"
        color="secondary"
        onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          e.stopPropagation();
          updateQuantity(item.id, item.quantity + 1);
        }}
        icon={<PlusIcon size={20} />}
      />
    </S.QuantityControls>
  ) : null;
};

export default QuantityControls;
